var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{staticClass:"conn_voer",attrs:{"show":_vm.show}},[_c('div',{staticClass:"connection-empty"},[_c('p',[_vm._v("您尚未注册参观本次展会，无权访问此页面")]),_c('p',[_vm._v("完成注册即可继续浏览")]),_c('van-button',{staticClass:"btn",attrs:{"round":"","color":"#f85b0f"},on:{"click":_vm.gotoReg}},[_vm._v("立即注册")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }